export default "__VITE_PUBLIC_ASSET__9e1541e6__"